export const rootUrl = process.env.REACT_APP_BASE_URL
